import { render } from "./SFSDateRange.vue?vue&type=template&id=0b09cb60&ts=true"
import script from "./SFSDateRange.vue?vue&type=script&lang=ts"
export * from "./SFSDateRange.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/t2_w86CdT/0/sfs-projects/development/station-handler-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__